import { render, staticRenderFns } from "./assign_worker.vue?vue&type=template&id=25a31326&scoped=true"
import script from "./assign_worker.vue?vue&type=script&lang=js"
export * from "./assign_worker.vue?vue&type=script&lang=js"
import style0 from "./assign_worker.vue?vue&type=style&index=0&id=25a31326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a31326",
  null
  
)

export default component.exports